import script from "./SearchCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchCenter.vue?vue&type=script&setup=true&lang=js"

import "./SearchCenter.vue?vue&type=style&index=0&id=75dd41fa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75dd41fa"]])

export default __exports__